import { gql } from 'graphql.macro'

export default gql`
  fragment PeriodFragment on Period {
    id
    unit
    value
  }
`
